import {
  orientationCredentialContract,
  type OrientationCredentialsResponse,
} from "@clipboard-health/contract-backend-main";
import { useGetParsedQuery, type UseGetParsedQueryOptions } from "@src/appV2/api/useGetParsedQuery";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { type UseQueryResult } from "@tanstack/react-query";

const { getOrientationCredentialsByWorker } = orientationCredentialContract;
const { 200: responseSchema } = getOrientationCredentialsByWorker.responses;

function getOrientationCredentialsUrl(workerId: string): string {
  return `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/orientation-credentials`;
}

export function useGetOrientationCredentials(
  options: UseGetParsedQueryOptions<typeof responseSchema> = {}
): UseQueryResult<OrientationCredentialsResponse> {
  const { userId: workerId } = useDefinedWorker();

  return useGetParsedQuery({
    url: getOrientationCredentialsUrl(workerId),
    responseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_ORIENTATION_CREDENTIALS_FAILURE,
    },
    ...options,
  });
}
